export const BASE_URL = process.env.REACT_APP_STATIC_URL as string
